import { css } from '@emotion/css';

export const linkStyles = css`
  .markup-container > *:first-child {
    margin-top: 0 !important;
  }

  .markup-container * {
    font-size: 1em;

    ol {
      gap: 0rem;
    }

    li::marker {
      font-size: 1em !important;
    }
    li {
      padding-inline-start: 0;
      margin-top: -1rem;
    }

    ol:not(:last-child),
    ul:not(:last-child) {
      li:last-of-type {
        margin-bottom: 1.4rem;
      }
    }

    ol:last-child,
    ul:last-child {
      li:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  a {
    word-break: break-all;
    color: var(--link-01);
  }

  pre {
    white-space: pre-wrap;
  }

  .isSingleEmoji {
    span.emoji {
      font-size: 3.2rem;
      vertical-align: bottom;
      line-height: 3.6rem;
    }
  }

  span.emoji {
    font-size: 1.6rem;
    vertical-align: bottom;
  }
`;
